// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { DataBlock, DataBlockT, verifyDataBlock } from "./data-block";
import { Vendor, VendorT, verifyVendor } from "./vendor";
import { LiftType } from "../archive/lift-type";
import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * Configuration — a complete offset configuration for a specific
 * vendor, lift type, and floor/stop count.
 */
export class Configuration implements flatbuffers.IUnpackableObject<ConfigurationT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): Configuration {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsConfiguration(bb: flatbuffers.ByteBuffer, obj?: Configuration): Configuration {
    return (obj || new Configuration()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsConfiguration(
    bb: flatbuffers.ByteBuffer,
    obj?: Configuration,
  ): Configuration {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new Configuration()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  id(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  vendorId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  name(): string | null;
  name(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  name(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  liftType(): LiftType {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : LiftType.ELEVATOR;
  }

  lifts(): number {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  stops(): number {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  rearDoor(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  createdAt(): string | null;
  createdAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  createdAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  updatedAt(): string | null;
  updatedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  updatedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  deletedAt(): string | null;
  deletedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  deletedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * Nested data blocks for this configuration (populated on detail endpoints).
   */
  dataBlocks(index: number, obj?: DataBlock): DataBlock | null {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset
      ? (obj || new DataBlock()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  dataBlocksLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Nested vendor for this configuration (populated on detail endpoints).
   */
  vendor(obj?: Vendor): Vendor | null {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset
      ? (obj || new Vendor()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  static startConfiguration(builder: flatbuffers.Builder) {
    builder.startObject(12);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, idOffset, 0);
  }

  static addVendorId(builder: flatbuffers.Builder, vendorIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, vendorIdOffset, 0);
  }

  static addName(builder: flatbuffers.Builder, nameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, nameOffset, 0);
  }

  static addLiftType(builder: flatbuffers.Builder, liftType: LiftType) {
    builder.addFieldInt8(3, liftType, LiftType.ELEVATOR);
  }

  static addLifts(builder: flatbuffers.Builder, lifts: number) {
    builder.addFieldInt32(4, lifts, 0);
  }

  static addStops(builder: flatbuffers.Builder, stops: number) {
    builder.addFieldInt32(5, stops, 0);
  }

  static addRearDoor(builder: flatbuffers.Builder, rearDoor: boolean) {
    builder.addFieldInt8(6, +rearDoor, +false);
  }

  static addCreatedAt(builder: flatbuffers.Builder, createdAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(7, createdAtOffset, 0);
  }

  static addUpdatedAt(builder: flatbuffers.Builder, updatedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(8, updatedAtOffset, 0);
  }

  static addDeletedAt(builder: flatbuffers.Builder, deletedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(9, deletedAtOffset, 0);
  }

  static addDataBlocks(builder: flatbuffers.Builder, dataBlocksOffset: flatbuffers.Offset) {
    builder.addFieldOffset(10, dataBlocksOffset, 0);
  }

  static createDataBlocksVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startDataBlocksVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addVendor(builder: flatbuffers.Builder, vendorOffset: flatbuffers.Offset) {
    builder.addFieldOffset(11, vendorOffset, 0);
  }

  static endConfiguration(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  unpack(): ConfigurationT {
    return new ConfigurationT(
      this.id() !== null ? this.id()!.unpack() : null,
      this.vendorId() !== null ? this.vendorId()!.unpack() : null,
      this.name(),
      this.liftType(),
      this.lifts(),
      this.stops(),
      this.rearDoor(),
      this.createdAt(),
      this.updatedAt(),
      this.deletedAt(),
      this.bb!.createObjList<DataBlock, DataBlockT>(
        this.dataBlocks.bind(this),
        this.dataBlocksLength(),
      ),
      this.vendor() !== null ? this.vendor()!.unpack() : null,
    );
  }

  unpackTo(_o: ConfigurationT): void {
    _o.id = this.id() !== null ? this.id()!.unpack() : null;
    _o.vendorId = this.vendorId() !== null ? this.vendorId()!.unpack() : null;
    _o.name = this.name();
    _o.liftType = this.liftType();
    _o.lifts = this.lifts();
    _o.stops = this.stops();
    _o.rearDoor = this.rearDoor();
    _o.createdAt = this.createdAt();
    _o.updatedAt = this.updatedAt();
    _o.deletedAt = this.deletedAt();
    _o.dataBlocks = this.bb!.createObjList<DataBlock, DataBlockT>(
      this.dataBlocks.bind(this),
      this.dataBlocksLength(),
    );
    _o.vendor = this.vendor() !== null ? this.vendor()!.unpack() : null;
  }

  unpackFields(...fields: string[]): ConfigurationT {
    const t = new ConfigurationT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id() !== null ? this.id()!.unpack() : null;
    }
    if (fieldSet.has("vendor_id")) {
      t.vendorId = this.vendorId() !== null ? this.vendorId()!.unpack() : null;
    }
    if (fieldSet.has("name")) {
      t.name = this.name();
    }
    if (fieldSet.has("lift_type")) {
      t.liftType = this.liftType();
    }
    if (fieldSet.has("lifts")) {
      t.lifts = this.lifts();
    }
    if (fieldSet.has("stops")) {
      t.stops = this.stops();
    }
    if (fieldSet.has("rear_door")) {
      t.rearDoor = this.rearDoor();
    }
    if (fieldSet.has("created_at")) {
      t.createdAt = this.createdAt();
    }
    if (fieldSet.has("updated_at")) {
      t.updatedAt = this.updatedAt();
    }
    if (fieldSet.has("deleted_at")) {
      t.deletedAt = this.deletedAt();
    }
    if (fieldSet.has("data_blocks")) {
      t.dataBlocks = this.bb!.createObjList<DataBlock, DataBlockT>(
        this.dataBlocks.bind(this),
        this.dataBlocksLength(),
      );
    }
    if (fieldSet.has("vendor")) {
      t.vendor = this.vendor() !== null ? this.vendor()!.unpack() : null;
    }
    return t;
  }
}

export class ConfigurationT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: UuidT | null = null,
    public vendorId: UuidT | null = null,
    public name: string | Uint8Array | null = null,
    public liftType: LiftType = LiftType.ELEVATOR,
    public lifts: number = 0,
    public stops: number = 0,
    public rearDoor: boolean = false,
    public createdAt: string | Uint8Array | null = null,
    public updatedAt: string | Uint8Array | null = null,
    public deletedAt: string | Uint8Array | null = null,
    public dataBlocks: DataBlockT[] = [],
    public vendor: VendorT | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const id = this.id !== null ? this.id!.pack(builder) : 0;
    const vendorId = this.vendorId !== null ? this.vendorId!.pack(builder) : 0;
    const name = this.name !== null ? builder.createString(this.name!) : 0;
    const createdAt = this.createdAt !== null ? builder.createString(this.createdAt!) : 0;
    const updatedAt = this.updatedAt !== null ? builder.createString(this.updatedAt!) : 0;
    const deletedAt = this.deletedAt !== null ? builder.createString(this.deletedAt!) : 0;
    const dataBlocks = Configuration.createDataBlocksVector(
      builder,
      builder.createObjectOffsetList(this.dataBlocks),
    );
    const vendor = this.vendor !== null ? this.vendor!.pack(builder) : 0;

    Configuration.startConfiguration(builder);
    Configuration.addId(builder, id);
    Configuration.addVendorId(builder, vendorId);
    Configuration.addName(builder, name);
    Configuration.addLiftType(builder, this.liftType);
    Configuration.addLifts(builder, this.lifts);
    Configuration.addStops(builder, this.stops);
    Configuration.addRearDoor(builder, this.rearDoor);
    Configuration.addCreatedAt(builder, createdAt);
    Configuration.addUpdatedAt(builder, updatedAt);
    Configuration.addDeletedAt(builder, deletedAt);
    Configuration.addDataBlocks(builder, dataBlocks);
    Configuration.addVendor(builder, vendor);

    return Configuration.endConfiguration(builder);
  }

  clone(): ConfigurationT {
    const obj = new ConfigurationT();
    obj.id = this.id !== null ? this.id!.clone() : null;
    obj.vendorId = this.vendorId !== null ? this.vendorId!.clone() : null;
    obj.name = this.name;
    obj.liftType = this.liftType;
    obj.lifts = this.lifts;
    obj.stops = this.stops;
    obj.rearDoor = this.rearDoor;
    obj.createdAt = this.createdAt;
    obj.updatedAt = this.updatedAt;
    obj.deletedAt = this.deletedAt;
    obj.dataBlocks = this.dataBlocks.map((e) => e.clone());
    obj.vendor = this.vendor !== null ? this.vendor!.clone() : null;
    return obj;
  }

  equals(other: ConfigurationT): boolean {
    if (this.id !== null && other.id !== null) {
      if (!this.id!.equals(other.id!)) return false;
    } else if (this.id !== other.id) return false;
    if (this.vendorId !== null && other.vendorId !== null) {
      if (!this.vendorId!.equals(other.vendorId!)) return false;
    } else if (this.vendorId !== other.vendorId) return false;
    if (this.name !== other.name) return false;
    if (this.liftType !== other.liftType) return false;
    if (this.lifts !== other.lifts) return false;
    if (this.stops !== other.stops) return false;
    if (this.rearDoor !== other.rearDoor) return false;
    if (this.createdAt !== other.createdAt) return false;
    if (this.updatedAt !== other.updatedAt) return false;
    if (this.deletedAt !== other.deletedAt) return false;
    if (this.dataBlocks.length !== other.dataBlocks.length) return false;
    for (let i = 0; i < this.dataBlocks.length; i++) {
      const a = this.dataBlocks[i];
      const b = other.dataBlocks[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.vendor !== null && other.vendor !== null) {
      if (!this.vendor!.equals(other.vendor!)) return false;
    } else if (this.vendor !== other.vendor) return false;
    return true;
  }
}

export function verifyConfiguration(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 10, 1);
    verifier.checkScalarField(tablePos, 12, 4);
    verifier.checkScalarField(tablePos, 14, 4);
    verifier.checkScalarField(tablePos, 16, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 18);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 20);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 22);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 24);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyDataBlock);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 26);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyVendor(verifier, fieldPos + tableOffset);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
